export default function LogoutIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9 6.56023C8.21 2.96023 10.06 1.49023 14.11 1.49023H14.24C18.71 1.49023 20.5 3.28023 20.5 7.75023V14.2702C20.5 18.7402 18.71 20.5302 14.24 20.5302H14.11C10.09 20.5302 8.24 19.0802 7.91 15.5402"
        stroke="#007D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 11H2.62"
        stroke="#007D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.85 7.65039L1.5 11.0004L4.85 14.3504"
        stroke="#007D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
